import handleErrors from './errors'
import handleSuccess from './success'

export const onResponseSuccess = (response) => handleSuccess(response)

export const onResponseError = (response) => handleErrors(response)
